import React from 'react';
import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <h1>Politique de Confidentialité</h1>
      <p><strong>Dernière mise à jour : Décembre 2025</strong></p>

      <p>
        Aaz Store accorde une grande importance à la protection des informations
        personnelles de ses clients. Cette Politique de Confidentialité explique
        comment vos données sont collectées, utilisées et protégées lors de
        l’utilisation du site.
      </p>

      <h2>1. Responsable des données</h2>
      <p>
        <strong>Aaz Store</strong><br />
        Email : contact@aazstore.com
      </p>

      <h2>2. Données collectées</h2>
      <p>Nous collectons uniquement les informations nécessaires au traitement des commandes :</p>
      <ul>
        <li>Nom et prénom</li>
        <li>Numéro de téléphone</li>
        <li>Adresse de livraison</li>
        <li>Adresse email (si fournie)</li>
        <li>Informations liées à la commande</li>
      </ul>

      <h2>3. Utilisation des données</h2>
      <p>Les données collectées sont utilisées pour :</p>
      <ul>
        <li>Traiter et livrer les commandes</li>
        <li>Contacter le client concernant sa commande</li>
        <li>Assurer le service client et les réclamations</li>
        <li>Améliorer les services proposés</li>
      </ul>

      <h2>4. Paiement</h2>
      <p>
        Les paiements effectués via <strong>Nita</strong> ou <strong>Amana</strong>
        sont traités directement par ces services.
        Aaz Store ne conserve aucune information bancaire ou financière.
      </p>

      <h2>5. Partage des données</h2>
      <p>
        Les données personnelles ne sont jamais vendues.
        Elles peuvent être partagées uniquement avec :
      </p>
      <ul>
        <li>Les services de livraison pour l’acheminement des commandes</li>
        <li>Les prestataires techniques nécessaires au fonctionnement du site</li>
        <li>Les autorités compétentes si la loi l’exige</li>
      </ul>

      <h2>6. Conservation des données</h2>
      <p>
        Les données sont conservées uniquement pendant la durée nécessaire
        au traitement des commandes et à la relation commerciale.
      </p>

      <h2>7. Sécurité</h2>
      <p>
        Aaz Store met en œuvre des mesures raisonnables pour protéger les données
        contre l’accès non autorisé, la perte ou l’utilisation abusive.
      </p>

      <h2>8. Cookies</h2>
      <p>
        Le site peut utiliser des cookies simples nécessaires à son bon fonctionnement
        (panier, navigation). L’utilisateur peut désactiver les cookies via son navigateur,
        ce qui peut limiter certaines fonctionnalités.
      </p>

      <h2>9. Droits des utilisateurs</h2>
      <p>
        Vous pouvez demander l’accès, la correction ou la suppression de vos informations
        personnelles en contactant Aaz Store.
      </p>

      <h2>10. Modification de la politique</h2>
      <p>
        Aaz Store se réserve le droit de modifier cette Politique de Confidentialité
        à tout moment. Les changements sont applicables dès leur publication sur le site.
      </p>

      <h2>11. Droit applicable</h2>
      <p>
        La présente Politique de Confidentialité est régie par le
        <strong> droit en vigueur au Niger</strong>.
      </p>

      <h2>12. Contact</h2>
      <p>
        Pour toute question concernant vos données personnelles :
        <br />
        <strong>Email :</strong> aazstore.niam@gmail.com
      </p>
    </div>
  );
}
